import { render } from "./Expand.vue?vue&type=template&id=7de387d9"
const script = {}
script.render = render

export default script